import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';

// profile routing
import { OpportunitiesModule } from '@amfam/opportunities';
import { OverviewBillingFeatureModule } from '@amfam/overview/billing/feature';
import { OverviewUiModule } from '@amfam/overview/ui';
// components/directives/pipes
import { SharedAnalyticsModule } from '@amfam/shared/analytics';
import { SharedFaqFeatureModule } from '@amfam/shared/faq/feature';
import { TooltipModule } from '@amfam/ui-kit';

// application modules
import { BillingModule } from '../billing/billing.module';
import { BusinessModule } from '../business/business.module';
import { ClaimModule } from '../claim/claim.module';
import { PolicyModule } from '../policy/policy.module';
import { ProfileModule } from '../profile/profile.module';
import { ProgramModule } from '../program/program.module';
import { SharedModule } from '../shared/shared.module';
import { TermsModule } from '../terms/terms.module';
import { AccountRoutingModule } from './account-routing.module';
import { AccountComponent } from './account.component';
import {
  AgentsOverviewComponent,
  OverviewComponent,
  PoliciesOverviewComponent,
  ProgramsOverviewComponent
} from './overview';
import { ClaimsOverviewComponent } from './overview/claims/claims-overview.component';
import { UpdateContactComponent } from './update-contact/update-contact.component';

@NgModule({
  imports: [
    SharedAnalyticsModule,
    SharedModule,
    AccountRoutingModule,
    BillingModule,
    PolicyModule,
    ProfileModule,
    ClaimModule,
    SharedFaqFeatureModule,
    TermsModule,
    BusinessModule,
    ProgramModule,
    OpportunitiesModule,
    OverviewBillingFeatureModule,
    OverviewUiModule,
    TooltipModule
  ],
  declarations: [
    AccountComponent,
    OverviewComponent,
    PoliciesOverviewComponent,
    AgentsOverviewComponent,
    ProgramsOverviewComponent,
    ClaimsOverviewComponent,
    UpdateContactComponent
  ],
  exports: [AccountComponent, OverviewComponent]
})
export class AccountModule {
  static forRoot(): ModuleWithProviders<AccountModule> {
    return {
      ngModule: AccountModule
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: AccountModule) {
    if (parentModule) {
      throw new Error('AccountModule is already loaded. Lazy load only');
    }
  }
}
